export class ProfileDto {
    public colorTheme?: "light" | "dark" | "system" = "system";
}
